/* JH quick add: loaded on every page from layout/theme.liquid */
/* JH quick add: bar -> size panel -> add -> "Added to your bag" popup */
(function () {
  if (window.jhQuickAdd) return;
  window.jhQuickAdd = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var money = function (cents) {
    return (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' });
  };
  var el = function (tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  };

  var popup, lastFocus;
  function buildPopup() {
    popup = el('div', 'jh-added');
    popup.hidden = true;
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'jh-added-title');
    var backdrop = el('div', 'jh-added__backdrop');
    var box = el('div', 'jh-added__box');
    var close = el('button', 'jh-added__close', '×');
    close.type = 'button';
    close.setAttribute('aria-label', 'Close');
    var title = el('h2', 'jh-added__title');
    title.id = 'jh-added-title';
    var body = el('div', 'jh-added__body');
    box.append(close, title, body);
    popup.append(backdrop, box);
    document.body.appendChild(popup);
    backdrop.addEventListener('click', hidePopup);
    close.addEventListener('click', hidePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !popup.hidden) hidePopup();
    });
  }
  function openPopup(titleText, nodes) {
    if (!popup) buildPopup();
    lastFocus = document.activeElement;
    popup.querySelector('.jh-added__title').textContent = titleText;
    var body = popup.querySelector('.jh-added__body');
    body.replaceChildren.apply(body, nodes);
    popup.hidden = false;
    popup.querySelector('.jh-added__close').focus();
  }
  function hidePopup() {
    if (!popup) return;
    popup.hidden = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function showAdded(info, cart) {
    var item = el('div', 'jh-added__item');
    if (info.image) {
      var img = el('img');
      img.src = info.image;
      img.alt = info.name;
      item.appendChild(img);
    }
    var meta = el('div', 'jh-added__info');
    meta.append(el('p', 'jh-added__name', info.name), el('p', 'jh-added__price', info.price));
    if (info.option) {
      var o = el('p');
      o.append(el('span', 'jh-added__muted', info.label + ': '), document.createTextNode(info.option));
      meta.appendChild(o);
    }
    var q = el('p');
    q.append(el('span', 'jh-added__muted', 'Qty: '), document.createTextNode('1'));
    meta.appendChild(q);
    item.appendChild(meta);

    var n = cart.item_count;
    var count = el('p', 'jh-added__count', n + (n === 1 ? ' item' : ' items') + ' in your bag ' + money(cart.total_price));

    var actions = el('div', 'jh-added__actions');
    var view = el('a', 'jh-added__view', 'View Bag');
    view.href = root + 'cart';
    var checkout = el('a', 'jh-added__checkout', 'Checkout');
    checkout.href = root + 'checkout';
    actions.append(view, checkout);

    openPopup('Added To Your Bag!', [item, count, actions]);
  }

  function showError(message) {
    openPopup('Could not add to bag', [el('p', 'jh-added__error', message || 'Please try again.')]);
  }

  function closePanels(except) {
    document.querySelectorAll('.jh-qa__sizes:not([hidden])').forEach(function (panel) {
      if (panel === except) return;
      panel.hidden = true;
      var bar = panel.parentElement.querySelector('.jh-qa__bar');
      if (bar) bar.setAttribute('aria-expanded', 'false');
    });
  }

  /* Recently Viewed cards: load current sizes from the store on first tap */
  function imgUrl(src) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=300';
  }

  async function loadSizes(qa, bar) {
    bar.setAttribute('aria-busy', 'true');
    try {
      var res = await fetch(root + 'products/' + encodeURIComponent(qa.dataset.handle) + '.js', {
        headers: { Accept: 'application/json' },
      });
      if (!res.ok) throw new Error('Product not found');
      var p = await res.json();
      var names = (p.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
      qa.dataset.label = names.join(' / ');
      var fallback = p.featured_image || '';

      if (!p.available) {
        bar.textContent = 'Sold Out';
        bar.disabled = true;
        return 'soldout';
      }

      if (p.variants.length === 1 && p.variants[0].title === 'Default Title') {
        var only = p.variants[0];
        bar.dataset.id = only.id;
        bar.dataset.price = money(only.price);
        bar.dataset.image = imgUrl((only.featured_image && only.featured_image.src) || fallback);
        return 'single';
      }

      var panel = el('div', 'jh-qa__sizes');
      panel.hidden = true;
      p.variants.forEach(function (v) {
        if (names.length > 1 && !v.available) return;
        var b = el('button', 'jh-qa__size', v.title);
        b.type = 'button';
        b.dataset.id = v.id;
        b.dataset.title = v.title;
        b.dataset.price = money(v.price);
        b.dataset.image = imgUrl((v.featured_image && v.featured_image.src) || fallback);
        if (!v.available) b.disabled = true;
        panel.appendChild(b);
      });
      qa.insertBefore(panel, bar);
      return 'panel';
    } finally {
      bar.removeAttribute('aria-busy');
    }
  }

  var busy = false;
  async function add(button, info) {
    if (busy) return;
    busy = true;
    button.setAttribute('aria-busy', 'true');

    var events = null;
    var deferred = null;
    try {
      events = await import('@shopify/events');
      deferred = events.CartLinesUpdateEvent.createPromise();
      button.dispatchEvent(
        new events.CartLinesUpdateEvent({
          action: 'add',
          context: 'product',
          lines: [{ merchandiseId: String(info.id), quantity: 1 }],
          promise: deferred.promise,
        })
      );
    } catch (e) {
      events = null;
      deferred = null;
    }

    try {
      var res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(info.id), quantity: 1 }] }),
      });
      var data = await res.json();
      var cart = await (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json();

      if (deferred) {
        deferred.resolve({
          cart: events.CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { items: cart.items, source: 'jh-quick-add', itemCount: 1, didError: !res.ok },
        });
      } else {
        var icon = document.querySelector('cart-icon');
        if (icon && icon.renderCartBubble) icon.renderCartBubble(cart.item_count);
      }

      closePanels();
      if (!res.ok) showError(data.description || data.message);
      else showAdded(info, cart);
    } catch (err) {
      if (deferred) deferred.reject(err);
      showError('Please check your connection and try again.');
    } finally {
      busy = false;
      button.removeAttribute('aria-busy');
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var target = e.target instanceof Element ? e.target : null;
      var qa = target && target.closest('.jh-qa');
      if (!qa) {
        closePanels();
        return;
      }
      e.preventDefault();
      e.stopPropagation();

      var base = { name: qa.dataset.name, label: qa.dataset.label };
      var size = target.closest('.jh-qa__size');
      if (size) {
        if (size.disabled) return;
        add(size, Object.assign(base, {
          id: size.dataset.id,
          option: size.dataset.title,
          price: size.dataset.price,
          image: size.dataset.image,
        }));
        return;
      }

      var bar = target.closest('.jh-qa__bar');
      if (!bar) return;
      if (bar.dataset.id) {
        add(bar, Object.assign(base, { id: bar.dataset.id, price: bar.dataset.price, image: bar.dataset.image }));
        return;
      }
      var panel = qa.querySelector('.jh-qa__sizes');
      if (!panel && qa.dataset.handle) {
        if (qa.dataset.loading || bar.disabled) return;
        qa.dataset.loading = '1';
        loadSizes(qa, bar)
          .then(function (kind) {
            if (kind === 'single') {
              add(bar, { name: qa.dataset.name, label: qa.dataset.label, id: bar.dataset.id, price: bar.dataset.price, image: bar.dataset.image });
            } else if (kind === 'panel') {
              var loaded = qa.querySelector('.jh-qa__sizes');
              closePanels(loaded);
              loaded.hidden = false;
              bar.setAttribute('aria-expanded', 'true');
            }
          })
          .catch(function () {
            showError('Could not load sizes. Please try again.');
          })
          .finally(function () {
            delete qa.dataset.loading;
          });
        return;
      }
      if (!panel) return;
      closePanels(panel);
      panel.hidden = !panel.hidden;
      bar.setAttribute('aria-expanded', panel.hidden ? 'false' : 'true');
    },
    true
  );
})();
